import axios from "axios";
import config from "../../../config";

const getReferentielData = async (reference) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios({
      method: "post",
      url: `${config.baseURL}/api/referentiel/getAll`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        cleReferentiel: reference,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReferentielDataFromServer = async (urlStatic = false, api, body, method = "post", params = {}) => {
  try {
    const response = await axios({
      method: method,
      url: urlStatic? api :`${config.baseURL}${api}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      data: {
        ...body,
      }, 
      //responseType: 'arraybuffer',
      ...params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default getReferentielData;
